import { createContext } from 'react';

export enum TileSizes {
  '400x400' = '-400x400-resize',
}

export const TileSizeContext = createContext<'' | TileSizes>('');

export const TileSizeProvider = TileSizeContext.Provider;
